import { render, staticRenderFns } from "./game-field.vue?vue&type=template&id=13e855c2&scoped=true&"
import script from "./game-field.vue?vue&type=script&lang=js&"
export * from "./game-field.vue?vue&type=script&lang=js&"
import style0 from "./game-field.vue?vue&type=style&index=0&id=13e855c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e855c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13e855c2')) {
      api.createRecord('13e855c2', component.options)
    } else {
      api.reload('13e855c2', component.options)
    }
    module.hot.accept("./game-field.vue?vue&type=template&id=13e855c2&scoped=true&", function () {
      api.rerender('13e855c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chicken-road/game-field.vue"
export default component.exports